import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import { Link } from "react-router-dom";

export default function ExchangeLink({ item, title }) {
  if (!item) {
    return false;
  }

  return (
    <p>
      {title}{" "}
      <Link to={`/sales-orders/${item.get("uuid")}`}>{item.get("code")}</Link>
    </p>
  );
}

ExchangeLink.propTypes = {
  item: T.instanceOf(Map),
  title: T.string.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/Form/Summary/ExchangeLink.jsx